// extracted by mini-css-extract-plugin
module.exports = {"add-task-wrapper":"tasks_tab__add-task-wrapper___1UxgL","addTaskWrapper":"tasks_tab__add-task-wrapper___1UxgL"};